import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { Link } from '../../PrivateLink/ServerLink';
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@/components/ui/empty';

export function NotFound() {
  const t = useTranslations('productsSearchPage');
  return (
    <Empty className='mt-[12px] gap-[16px] p-0 md:mt-[24px] md:p-0'>
      <EmptyHeader className='max-w-[280px] gap-[16px]'>
        <EmptyMedia className='mb-0 px-[60px]'>
          <Image src='/assets/images/not-found.webp' alt='not found' height={103} width={154} />
        </EmptyMedia>
        <EmptyTitle className='px-[15px] text-[18px] font-medium tracking-normal'>
          <h1>{t('not_found')}</h1>
        </EmptyTitle>
        <EmptyDescription className='px-[15px] text-[16px] font-normal text-text-disabled-day'>
          {t('not_found_hint')}
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent className='max-w-[280px]'>
        <Link
          href='/'
          className='w-full bg-primary-green-day rounded-[12px] py-[10px] flex items-center justify-center text-bg-day'
        >
          {t('go_main')}
        </Link>
      </EmptyContent>
    </Empty>
  );
}
